import React from "react";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";
import QRCode from "react-native-qrcode-svg";

import Ethbaloon from "@/assets/ethballoon.svg";

type WalletInformationProps = {
  address: string;
  chain: string;
};

export default function WalletInformation(props: WalletInformationProps) {
  const { t } = useTranslation();
  return (
    <View className="w-full items-center">
      {props.address && props.chain ? (
        <View className="items-center gap-4">
          <QRCode
            value={`${props.chain}:${props.address}`}
            size={100}
            logoBackgroundColor="transparent"
          />
          <View className="items-center">
            <Text className="text-xl">
              {t("home/web3/index:sections.wallet.items.address")}
            </Text>
            <Text className="text-xl font-light">{props.address}</Text>
          </View>
          <View className="items-center">
            <Text className="text-xl">
              {t("home/web3/index:sections.wallet.items.chain")}
            </Text>
            <Text className="text-xl font-light">{props.chain}</Text>
          </View>
        </View>
      ) : (
        <View className="gap-4 items-center">
          <Text className="text-3xl text-center">
            {t("home/web3/index:sections.wallet.connect")}
          </Text>
          <Ethbaloon width={200} height={200} />
        </View>
      )}
    </View>
  );
}
